import React from 'react';
import { Col, Container, Row, Card } from 'reactstrap';
import One_Stop_Solution from "../../../assets/images/home/One_Stop_Solution.png";
import Daas from "../../../assets/images/home/Daas.png";
import Guaranteed_Cost_Reduction from "../../../assets/images/home/Guaranteed_Cost_Reduction.png";
import Technology_Driven from "../../../assets/images/home/Technology_Driven.png";
import Vendor_Optimization from "../../../assets/images/home/Vendor_Optimization.png";
import Client1 from "../../../assets/images/clients/ACA_TM_rgb_4c_pos.png.png";
import Client2 from "../../../assets/images/clients/Acuity logo.png";
import Client3 from "../../../assets/images/clients/Atlas Copco.png";
import Client4 from "../../../assets/images/clients/Burckhardt-Compression-Logo-2020.jpg";
import Client5 from "../../../assets/images/clients/CIE India.png";
import Client6 from "../../../assets/images/clients/DIAM-logo-light-140height.png";
import Client7 from "../../../assets/images/clients/DViO.jpeg";
import Client8 from "../../../assets/images/clients/Druva Software.png";
import Client9 from "../../../assets/images/clients/EKA.png";
import Client10 from "../../../assets/images/clients/HILTI .jpg";
import Client11 from "../../../assets/images/clients/Harman logo.png";
import Client12 from "../../../assets/images/clients/Magna logo.png";
import Client13 from "../../../assets/images/clients/Mahle.jpg";
import Client14 from "../../../assets/images/clients/Matrix logo.png";
import Client15 from "../../../assets/images/clients/Mercedes Benz.png";
import Client16 from "../../../assets/images/clients/NICE.png";
import Client17 from "../../../assets/images/clients/NUTANIX.png";
import Client18 from "../../../assets/images/clients/Nasdaq.png";
import Client19 from "../../../assets/images/clients/Netcracker.png";
import Client20 from "../../../assets/images/clients/New balance.png";
import Client21 from "../../../assets/images/clients/Oriental Yeast India.png";
import Client22 from "../../../assets/images/clients/Pinnacle Industries Limited.png";
import Client23 from "../../../assets/images/clients/Schindler.jpeg";
import Client24 from "../../../assets/images/clients/Schlumberger.png";
import Client25 from "../../../assets/images/clients/Siemens india Limited.png";
import Client26 from "../../../assets/images/clients/Springer Nature Technology and Publishing Solution Private Limited.png";
import Client27 from "../../../assets/images/clients/TATA Management Training Center.png";
import Client28 from "../../../assets/images/clients/TATA Technologies Limited.png";
import Client29 from "../../../assets/images/clients/Tata bluescope.png";
import Client30 from "../../../assets/images/clients/asianpaints.jpg";
import Client31 from "../../../assets/images/clients/deutsche-bank-aundh-pune-banks-3t3v2ow.png";
import Client32 from "../../../assets/images/clients/lentra.jpg";
import Client33 from "../../../assets/images/clients/nxp_india_logo.jpeg";
import Client34 from "../../../assets/images/clients/prescient-technologies-pvt-ltd.png";
import Client35 from "../../../assets/images/clients/pune metro.png";
import Client36 from "../../../assets/images/clients/scheffler.png";
import Marquee from "react-fast-marquee";
const Clients = () => {
    const clients = [

        { src: Client1, alt: "ACA" },
        { src: Client2, alt: "Acuity" },
        { src: Client3, alt: "Atlas" },
        { src: Client4, alt: "Burckhardt" },
        { src: Client5, alt: "CIE India" },
        { src: Client6, alt: "DIAM" },
        { src: Client7, alt: "DViO" },
        { src: Client8, alt: "Druva Software" },
        { src: Client9, alt: "EKA" },
        { src: Client10, alt: "HILTI" },
        { src: Client11, alt: "Harman" },
        { src: Client12, alt: "Magna" },
        { src: Client13, alt: "Mahle" },
        { src: Client14, alt: "Matrix" },
        { src: Client15, alt: "Mercedes Benz" },
        { src: Client16, alt: "NICE" },
        { src: Client17, alt: "NUTANIX" },
        { src: Client18, alt: "Nasdaq" },
        { src: Client19, alt: "Netcracker" },
        { src: Client20, alt: "New Balance" },
        { src: Client21, alt: "Oriental Yeast India" },
        { src: Client22, alt: "Pinnacle Industries" },
        { src: Client23, alt: "Schindler" },
        { src: Client24, alt: "Schlumberger" },
        { src: Client25, alt: "Siemens India Limited" },
        { src: Client26, alt: "Springer Nature Technology and Publishing Solution Private Limited" },
        { src: Client27, alt: "TATA Management Training Center" },
        { src: Client28, alt: "TATA Technologies Limited" },
        { src: Client29, alt: "Tata bluescope" },
        { src: Client30, alt: "Asian Paints" },
        { src: Client31, alt: "Deutsche Bank" },
        { src: Client32, alt: "Lentra" },
        { src: Client33, alt: "NXP India" },
        { src: Client34, alt: "Prescient Technologies" },
        { src: Client35, alt: "Pune Metro" },
        { src: Client36, alt: "Scheffler" },

    ];
    const clientsPerRow = Math.ceil(clients.length / 3);
    const row1Clients = clients.slice(0, clientsPerRow);
    const row2Clients = clients.slice(clientsPerRow, clientsPerRow * 2);
    const row3Clients = clients.slice(clientsPerRow * 2, clients.length);


    return (
        <React.Fragment>

            <section className="section  py-5" id="features" style={{ backgroundColor: "rgb(52, 81, 159)", color: "rgb(250 250 250)" }}>
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center mt-5">
                                <h2 className="fw-bold" style={{ color: "white", fontSize: "2rem" }}>What we Do?</h2>
                                <p style={{ color: "white", maxWidth: "700px", margin: "0 auto" }}>
                                    Team of professionals solving key problems of corporate’s indirect purchases.
                                    Simplifying office supplies across categories.
                                </p>
                                <div className="container mt-5">
                                    <div className="row g-4">

                                        {[
                                            { title: "One Stop Solution", desc: "One supplier for multiple admin services across Pan India.", img: One_Stop_Solution },
                                            { title: "Guaranteed Cost Reduction", desc: "Building consolidated supply for multiple product and services.", img: Guaranteed_Cost_Reduction },
                                            { title: "Vendor Optimization", desc: "A single vendor for multiple admin services across Pan India.", img: Vendor_Optimization }
                                        ].map((item, index) => (
                                            <div key={index} className="col-md-4 d-flex align-items-stretch">

                                                <Card className="p-3 d-flex align-items-center w-100" style={{ minHeight: "180px", backgroundColor: "white", color: "black" }}>
                                                    <img src={item.img} alt={item.title} className="me-3" style={{ width: "50px", height: "50px" }} />
                                                    <div>
                                                        <h5 className="fw-semibold flex-grow-0 mt-3" >{item.title}</h5>
                                                        <p className="text-muted ">{item.desc}</p>
                                                    </div>
                                                </Card>
                                            </div>
                                        ))}
                                    </div>


                                    <div className="row g-4 justify-content-center">
                                        {[
                                            { title: "Technology Driven", desc: "In-house technology optimizing processes on Invoicing, Tracking, Accounting, Ledger and Deliveries.", img: Technology_Driven },
                                            { title: "Daas", desc: "Distribution As a Service – Plug and Play platform to promote a brand to corporate companies across Pan India.", img: Daas }
                                        ].map((item, index) => (
                                            <div key={index} className="col-md-5 d-flex align-items-stretch">
                                                <Card className="p-3 d-flex align-items-center w-100" style={{ minHeight: "180px", backgroundColor: "white", color: "black" }}>
                                                    <img src={item.img} alt={item.title} className="me-3" style={{ width: "50px", height: "50px" }} />
                                                    <div>
                                                        <h5 className="fw-semibold flex-grow-0 mt-3" >{item.title}</h5>
                                                        <p className="text-muted ">{item.desc}</p>
                                                    </div>
                                                </Card>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <h4 className="text-center mb-4 fw-bold">Clients</h4>
                                {[row3Clients, row1Clients, row2Clients].map((clients, rowIndex) => (
                                    <Marquee
                                        key={rowIndex}
                                        gradient={false}
                                        speed={rowIndex === 1 ? 40 : rowIndex === 2 ? 40 : 40}
                                        pauseOnHover={true}
                                        direction={rowIndex === 1 ? "right" : "left"}
                                        className="mb-3"
                                    >
                                        {clients.map((client, index) => (
                                            <div
                                                key={index}
                                                className="mx-3 d-flex align-items-center justify-content-center"
                                                style={{ width: "150px", height: "70px" }}
                                            >
                                                <img
                                                    src={client.src}
                                                    alt={client.alt}
                                                    style={{ maxHeight: "60px", maxWidth: "130px", objectFit: "contain", display: "block" }}
                                                />
                                            </div>
                                        ))}
                                    </Marquee>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Clients;